import { useModal } from "../ModalContext";
import { db } from "../firebase";
import { doc, setDoc, getDoc, onSnapshot } from "firebase/firestore";
import { useState, useEffect } from "react";

function PostModal() {
  const { postModal, setPostModal, setUserModal } = useModal();
  const [fullImage, setFullImage] = useState(false);
  const { posts = [], index = 0, ownerUsername } = postModal || {};
  const [livePosts, setLivePosts] = useState(posts);

  const [animateIn, setAnimateIn] = useState(false);

  const [likeAnimating, setLikeAnimating] = useState(false);

  const [likeAnim, setLikeAnim] = useState(false);

  const [comment, setComment] = useState("");
  const [replyTo, setReplyTo] = useState(null);
  const [collapsed, setCollapsed] = useState({});
  const [userAvatar, setUserAvatar] = useState("");

  const username = localStorage.getItem("user");

  const [scale, setScale] = useState(1);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });

  const closeModal = () => setPostModal(null);
  const [hoverDelete, setHoverDelete] = useState(false);

  const post = livePosts[index] || { comments: [], likes: [] };

  const [likeShakeAnim, setLikeShakeAnim] = useState(false);

  useEffect(() => {
  if (!ownerUsername) return;

  const ref = doc(db, "users", ownerUsername);
  

  const unsub = onSnapshot(ref, (snap) => {
    if (snap.exists()) {
      const data = snap.data();

      const safePosts = (data.posts || []).map(p => ({
        ...p,
        comments: p.comments || [],
        likes: p.likes || []
      }));

      setLivePosts(safePosts);
    }
  });

  return () => unsub();
}, [ownerUsername]);

  // 👉 загрузка аватарки текущего пользователя
  useEffect(() => {
    const loadUser = async () => {
      if (!username) return;

      const snap = await getDoc(doc(db, "users", username));
      if (snap.exists()) {
        setUserAvatar(snap.data().avatar || "");
      }
    };

    loadUser();
  }, [username]);

  // 👉 клавиши
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowRight") nextPost();
      if (e.key === "ArrowLeft") prevPost();
      if (e.key === "Escape") closeModal();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [index, livePosts.length]);

  if (!ownerUsername || !livePosts.length) return null;
  

  // 👉 навигация
  const nextPost = () => {
    if (index < livePosts.length - 1) {
      setPostModal({ ...postModal, index: index + 1 });
    }
  };

  const prevPost = () => {
    if (index > 0) {
      setPostModal({ ...postModal, index: index - 1 });
    }
  };

  // 👉 лайк
const toggleLike = async () => {
  setLikeAnimating(true);
  setLikeShakeAnim(true);

  setTimeout(() => setLikeAnimating(false), 300);
  setTimeout(() => setLikeShakeAnim(false), 250);

  const updated = livePosts.map((p, i) => {
    if (i !== index) return p;

    const likes = p.likes || [];

    return {
      ...p,
      likes: likes.includes(username)
        ? likes.filter(u => u !== username)
        : [...likes, username]
    };
  });

  setPostModal({ ...postModal, posts: updated });

  await setDoc(doc(db, "users", ownerUsername), { posts: updated }, { merge: true });
};

  // 👉 добавить комментарий
  const addComment = async () => {
    if (!comment.trim()) return;

    const newComment = {
      id: Date.now(),
      user: username,
      text: comment,
      replyTo: replyTo ?? null,
      avatar: userAvatar || "",
      time: Date.now()
    };

    const updated = livePosts.map((p, i) => {
      if (i !== index) return p;

      return {
        ...p,
        comments: [...(p.comments || []), newComment]
      };
    });

    // 🔥 ВАЖНО: обновляем модалку сразу
    setPostModal({ ...postModal, posts: updated });

    await setDoc(doc(db, "users", ownerUsername), { posts: updated }, { merge: true });

    setComment("");
    setReplyTo(null); // 👈 фикс бага ответа
  };

  // 👉 удалить комментарий
  const deleteById = async (id) => {
    const updated = livePosts.map((p, i) => {
      if (i !== index) return p;

      return {
        ...p,
        comments: (p.comments || []).filter(c => c.id !== id)
      };
    });

    // 🔥 обновляем UI сразу
    setPostModal({ ...postModal, posts: updated });

    await setDoc(doc(db, "users", ownerUsername), { posts: updated }, { merge: true });
  };

  const openUserModal = async (user) => {
    const snap = await getDoc(doc(db, "users", user));
    if (snap.exists()) {
      setUserModal({ username: user, ...snap.data() });
    }
  };

  const toggleCollapse = (id) => {
    setCollapsed(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  // 👉 рендер комментариев
  const renderComments = (comments = [], parentId = null, level = 0) => {
    return comments
      .filter(c => (c.replyTo ?? null) === parentId)
      .map((c) => {
        const isCollapsed = collapsed[c.id];
        const hasReplies = comments.some(x => x.replyTo === c.id);

        return (
          <div
                key={c.id}
                style={{
                    marginLeft: level * 20,
                    marginTop: 10,
                    ...styles.commentAppear
                }}
                >
            <div style={styles.commentRow}>

              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img
                  src={c.avatar || "https://via.placeholder.com/40"}
                  style={styles.commentAvatar}
                  onClick={() => openUserModal(c.user)}
                />

                {hasReplies && (
                  <span onClick={() => toggleCollapse(c.id)} style={styles.collapseBtn}>
                    {isCollapsed ? "▶" : "▼"}
                  </span>
                )}
              </div>

              <div style={styles.commentBubble}>
                <b style={{ color: "#fff" }}>{c.user}</b>
                <div style={{ color: "#fff" }}>{c.text}</div>

                <div style={styles.commentActions}>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      setReplyTo(c.id);
                    }}
                  >
                    ответить
                  </span>

                  {c.user === username && (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteById(c.id);
                      }}
                    >
                      удалить
                    </span>
                  )}
                </div>
              </div>
            </div>

            {!isCollapsed && renderComments(comments, c.id, level + 1)}
          </div>
        );
      });
  };

  return (
    <div
  style={styles.modal}
  onClick={(e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  }}
>
      <button onClick={closeModal} style={styles.closeBtn}>✕</button>

      <button onClick={prevPost} style={styles.leftArrow}>‹</button>
      <button onClick={nextPost} style={styles.rightArrow}>›</button>

              {ownerUsername === username && (
              <button
            onClick={async () => {
                const updated = livePosts.filter((_, i) => i !== index);

                await setDoc(doc(db, "users", ownerUsername), { posts: updated }, { merge: true });

                closeModal();
            }}
            onMouseEnter={() => setHoverDelete(true)}
            onMouseLeave={() => setHoverDelete(false)}
            style={{
                ...styles.deleteBtn,
                background: hoverDelete ? "rgba(255,107,107,0.15)" : styles.deleteBtn.background,
                border: hoverDelete ? "1px solid rgba(255,107,107,0.6)" : styles.deleteBtn.border
            }}
            >
            удалить
            </button>
            )}

      <div style={styles.postModalContent}>

        <img
            src={post.image}
            style={styles.modalImg}
            onClick={() => {
                setFullImage(true);
                setScale(1);
                setPosition({ x: 0, y: 0 });
                setTimeout(() => setAnimateIn(true), 10);
                }}
            />

        <div style={styles.caption}>{post.caption}</div>

        <div style={styles.actions}>
          <span
            onClick={toggleLike}
            style={{
                ...styles.likeBtn,
                ...(post.likes || []).includes(username)
                ? styles.liked
                : {}
            }}
            >
            <span
            style={{
                ...styles.heart,
                ...(likeAnimating ? styles.likeAnimate : {}),
                ...(likeShakeAnim ? styles.likeShake : {})
            }}
            >
            ❤
            </span>

            <span style={styles.likeCount}>
                {(post.likes || []).length}
            </span>
            </span>
          <span>💬 {(post.comments || []).length}</span>
        </div>

        <div style={styles.commentsBox}>
          {renderComments(post.comments || [])}
        </div>

        <div style={styles.commentInputBox}>
         <textarea
                placeholder={replyTo ? "Ответ..." : "Комментарий..."}
                value={comment}
                onChange={(e) => setComment(e.target.value)}

                onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    addComment();
                    }
                }}

                style={styles.textarea}
                />
          <button onClick={addComment} style={styles.sendBtn}>➤</button>
        </div>

{fullImage && (
  <div
  style={{
    ...styles.fullscreenOverlay,
    opacity: animateIn ? 1 : 0
  }}
  onWheel={(e) => {
  e.preventDefault();

  let newScale = scale + (e.deltaY > 0 ? -0.1 : 0.1);

  if (newScale < 1) newScale = 1;
  if (newScale > 4) newScale = 4;

  setScale(newScale);
}}
>
    onClick={() => {
        setAnimateIn(false);
        setTimeout(() => setFullImage(false), 200);
        }}

    <img
  src={post.image}
  style={{
  ...styles.fullscreenImg,
  transform: `
    scale(${scale})
    translate(${position.x}px, ${position.y}px)
  `,
  opacity: animateIn ? 1 : 0,
  transition: dragging ? "none" : "all 0.2s ease",
  cursor: dragging ? "grabbing" : "grab"
}}
  onClick={(e) => e.stopPropagation()}

  onMouseDown={(e) => {
  setDragging(true);
  setStartPos({
    x: e.clientX - position.x,
    y: e.clientY - position.y
  });
    }}

    onMouseMove={(e) => {
    if (!dragging) return;

    setPosition({
        x: e.clientX - startPos.x,
        y: e.clientY - startPos.y
    });
    }}

    onMouseUp={() => setDragging(false)}
    onMouseLeave={() => setDragging(false)}
/>

    {/* ❌ кнопка закрытия */}
    <button
      onClick={() => {
        setAnimateIn(false);
        setTimeout(() => setFullImage(false), 200);
      }}
      style={styles.fullscreenClose}
    >
      ✕
    </button>
  </div>
)}
      </div>
    </div>
  );
}

const styles = {
  modal: {
  position: "fixed",
  inset: 0,

  background: "rgba(0,0,0,0.5)",   // 👈 затемнение
  backdropFilter: "blur(10px)",    // 👈 САМ БЛЮР
  WebkitBackdropFilter: "blur(10px)", // 👈 для Safari

  display: "flex",
  alignItems: "center",
  justifyContent: "center"
},

  postModalContent: {
  width: "90%",
  maxWidth: 600,
  maxHeight: "90vh",              // 👈 фикс высота
  background: "#1e1e1e",
  borderRadius: 16,
  padding: 20,
  overflowY: "auto",           // 👈 скролл тут
  position: "relative",

  // 👇 КРАСИВЫЙ СКРОЛЛ
  scrollbarWidth: "thin",
  scrollbarColor: "rgba(255,255,255,0.2) transparent"
},

  modalImg: {
    width: "100%",
    maxHeight: "60vh",
    objectFit: "contain",
    borderRadius: 10
  },

  caption: {
    marginTop: 10,
    textAlign: "center",
    color: "#ccc"
  },

  actions: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 10,
    color: "#fff"
  },

  commentsBox: {
  marginTop: 10
},

  commentRow: { display: "flex", gap: 10 },

  commentAvatar: {
    width: 35,
    height: 35,
    borderRadius: "50%",
    cursor: "pointer"
  },

  commentBubble: {
    background: "#333",
    padding: 10,
    borderRadius: 10,
    flex: 1
  },

  commentActions: {
    fontSize: 12,
    marginTop: 5,
    display: "flex",
    gap: 10,
    cursor: "pointer",
    color: "#aaa"
  },

  commentInputBox: {
    display: "flex",
    marginTop: 10,
    gap: 8
  },

  textarea: {
    flex: 1,
    padding: 10,
    borderRadius: 10,
    border: "none",
    background: "#333",
    color: "#fff"
  },

  sendBtn: {
    padding: "0 15px",
    borderRadius: 10,
    border: "none",
    background: "#444",
    color: "#fff",
    cursor: "pointer"
  },

  closeBtn: {
    position: "fixed",
    top: 20,
    right: 20,
    background: "transparent",
    border: "none",
    color: "#fff",
    fontSize: 24,
    cursor: "pointer"
  },

  deleteBtn: {
  position: "absolute",
  top: 15,
  left: 15,

  padding: "6px 12px",
  borderRadius: 8,
  background: "rgba(255,255,255,0.05)",  // 👈 мягкий фон
  color: "#ff6b6b",                      // 👈 акцентный цвет
  border: "1px solid rgba(255,107,107,0.3)",
  fontSize: 13,
  cursor: "pointer",
  transition: "all 0.2s ease"
},

  leftArrow: {
    position: "fixed",
    left: 20,
    top: "50%",
    fontSize: 40,
    background: "transparent",
    border: "none",
    color: "#fff",
    cursor: "pointer"
  },

  rightArrow: {
    position: "fixed",
    right: 20,
    top: "50%",
    fontSize: 40,
    background: "transparent",
    border: "none",
    color: "#fff",
    cursor: "pointer"
  },

  // для Chrome
  postModalContentScroll: {
        "&::-webkit-scrollbar": {
            width: "6px"
        },
        "&::-webkit-scrollbar-thumb": {
            background: "rgba(255,255,255,0.2)",
            borderRadius: "10px"
        }
  },

  topBar: {
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: 10
},

  collapseBtn: {
  cursor: "pointer",
  color: "#aaa",
  fontSize: 12,
  marginTop: 4
},

fullscreenOverlay: {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.95)",
  backdropFilter: "blur(10px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  transition: "opacity 0.2s ease"
},

fullscreenImg: {
  maxWidth: "95%",
  maxHeight: "95%",
  objectFit: "contain",
  borderRadius: 12,
  transition: "all 0.2s ease"
},

fullscreenClose: {
  position: "fixed",
  top: 20,
  right: 20,
  fontSize: 28,
  background: "transparent",
  border: "none",
  color: "#fff",
  cursor: "pointer"
},

commentAppear: {
  animation: "commentFadeIn 0.3s ease"
},

likeBtn: {
  cursor: "pointer",
  transition: "all 0.2s ease",
  userSelect: "none"
},

liked: {
  color: "#ff4d6d",
  transform: "scale(1.05)"
},

likeAnimate: {
  animation: "pulseLike 0.4s ease"
},

likeBtn: {
  display: "flex",
  alignItems: "center",
  gap: 6,
  cursor: "pointer",
  color: "#aaa",
  transition: "all 0.2s ease",
  userSelect: "none"
},

heart: {
  fontSize: 16,
  transition: "all 0.2s ease"
},

likeCount: {
  fontSize: 13,
  opacity: 0.8
},

liked: {
  color: "#ff4d4d"
},

likeAnimate: {
  transform: "scale(1.25)"
},

likeShake: {
  animation: "likeShake 0.25s ease"
},

};

if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.innerHTML = `
    @keyframes commentFadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
  document.head.appendChild(style);
}

if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.innerHTML += `
    @keyframes likePop {
      0% { transform: scale(1); }
      50% { transform: scale(1.3); }
      100% { transform: scale(1); }
    }
  `;
  document.head.appendChild(style);
}

export default PostModal;